// extracted by mini-css-extract-plugin
module.exports = {"panel":"_020d45e","shadow":"_34d7822"};